import { ReactNode } from 'react'

import classNames from 'classnames'

interface IconProps {
  children: ReactNode
  bgColor?: string
}

const Icon = ({ children, bgColor = 'bg-gray-200' }: IconProps) => (
  <span
    className={classNames([
      'flex justify-center items-center w-10 h-10 min-w-10 rounded-lg',
      bgColor,
    ])}
  >
    {children}
  </span>
)

export default Icon
